import { render, staticRenderFns } from "./clean-button.component.vue?vue&type=template&id=28ecb044&scoped=true"
import script from "./clean-button.component.vue?vue&type=script&lang=js"
export * from "./clean-button.component.vue?vue&type=script&lang=js"
import style0 from "./clean-button.component.vue?vue&type=style&index=0&id=28ecb044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ecb044",
  null
  
)

export default component.exports